// Tarjeta «HOY, hasta ahora» — folios vivos de Noray (endpoint /hoy, api v0.3.6).
// PROVISIONAL a propósito y declarado: enseña la hora de la última sync y avisa
// de que la cifra oficial del día llega con el volcado contable. Solo aparece
// en LIVE con datos — en demo o sin red no ocupa sitio (api.hoy() → null).
import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, View, Pressable } from 'react-native';
import { api, type HoyLive } from '@/api/client';
import { C, F } from '@/constants/theme';
import { fmtE } from '@/lib/format';
import { Card, Chip, SectionTitle } from './ui';

export default function HoyCard() {
  const [hoy, setHoy] = useState<HoyLive | null>(null);
  /* 🔴 TOCAR LA TARJETA ABRE LA LISTA COMPLETA. Patricio lo pidió dos veces: «si
     presiona en esa tarjeta que pueda ver rápidamente lo de hoy de todos los
     hoteles». Antes se veían tres y no había forma de ver el resto sin cambiar
     de pantalla. Se despliega aquí mismo, sin navegar: en una demo, cada toque
     que cambia de pantalla es una oportunidad de perder el hilo. */
  const [abierta, setAbierta] = useState(false);
  useEffect(() => { api.hoy().then(setHoy); }, []);
  if (!hoy || !hoy.total) return null;
  const lista = abierta ? hoy.hoteles : hoy.hoteles.slice(0, 3);
  return (
    <Pressable onPress={() => setAbierta((v) => !v)}>
    <Card>
      <SectionTitle right="provisional · cuenta huésped">{`Hoy, hasta las ${hoy.ultSync ?? '—'}`}</SectionTitle>
      <Text style={s.total}>{fmtE(hoy.total)}</Text>
      <Text style={s.sub}>{hoy.hotelesConDatos} hoteles Noray ya tienen folios (cuenta huésped) del día</Text>
      <View style={{ marginTop: 10, gap: 6 }}>
        {lista.map((h, i) => (
          <View key={h.id} style={s.row}>
            <Text style={s.rank}>{String(i + 1)}</Text>
            <Text style={s.name} numberOfLines={1}>{h.n.replace('Ona ', '')}</Text>
            <Text style={s.val}>{fmtE(h.imp)}</Text>
          </View>
        ))}
      </View>
      <View style={s.chips}>
        {hoy.puntos.slice(0, 3).map((p) => (
          <Chip key={`${p.cat}|${p.punto}`}>{`${p.punto} · ${fmtE(p.imp)}`}</Chip>
        ))}
      </View>
      {/* 🔴 EL RÓTULO PROMETE LO QUE HAY, NO LO QUE HABRÍA. Cuenta sobre
          `hoy.hoteles`, que es lo que el API ha mandado de verdad — no sobre
          `hotelesConDatos`, que cuenta antes del recorte del servidor. Si un día
          vuelve a haber tope, la tarjeta dirá la verdad en vez de abrirse con
          menos hoteles de los que anunció. */}
      {hoy.hoteles.length > 3 ? (
        <Text style={s.verTodos}>
          {abierta
            ? 'toca para plegar ▴'
            : `toca para ver los ${hoy.hoteles.length} hoteles ▾`}
        </Text>
      ) : null}
      <Text style={s.foot}>Neto sin IVA. La cifra oficial del día llega con el volcado contable de mañana.</Text>
    </Card>
    </Pressable>
  );
}

const s = StyleSheet.create({
  total: { fontFamily: F.display, fontSize: 30, color: C.ink, marginTop: 2 },
  sub: { fontFamily: F.ui, fontSize: 11.5, color: C.muted, marginTop: 2 },
  row: { flexDirection: 'row', alignItems: 'center', gap: 10 },
  rank: { width: 16, textAlign: 'center', fontFamily: F.ui, fontSize: 11.5, color: C.faint },
  name: { flex: 1, fontFamily: F.uiMed, fontSize: 12.5, color: C.ink },
  val: { fontFamily: F.uiBold, fontSize: 12.5, color: C.ink, fontVariant: ['tabular-nums'] },
  chips: { flexDirection: 'row', flexWrap: 'wrap', gap: 8, marginTop: 12 },
  foot: { fontFamily: F.ui, fontSize: 10, color: C.faint, marginTop: 10, lineHeight: 14 },
  verTodos: { fontFamily: F.uiMed, fontSize: 11, color: C.aquaSoft, marginTop: 10 },
});
